import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronRight, FileText, RefreshCcw, Store, Users } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/admin/')({
  component: AdminIndex,
})

function AdminIndex() {
  return (
    <main className="mx-auto flex w-full max-w-4xl flex-col gap-4 px-4 py-6 pb-12">
      <header className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">Админ-панель</h1>
        <p className="text-sm text-muted-foreground">
          Управление пилотом: пользователи, магазины и ретрай упавших job.
        </p>
      </header>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <NavCard
          to="/admin/users"
          title="Пользователи"
          description="Создавайте аккаунты, сбрасывайте пароли, привязывайте к магазинам."
          icon={<Users className="h-5 w-5" aria-hidden="true" />}
        />
        <NavCard
          to="/admin/stores"
          title="Магазины"
          description="Заводите торговые точки и редактируйте их."
          icon={<Store className="h-5 w-5" aria-hidden="true" />}
        />
        <NavCard
          to="/admin/processing"
          title="Упавшие"
          description="Перезапустите консультации, не дошедшие до анализа."
          icon={<RefreshCcw className="h-5 w-5" aria-hidden="true" />}
        />
        <NavCard
          to="/admin/system-prompt"
          title="Системный промт"
          description="Редактируйте текст промта и переключайтесь между версиями."
          icon={<FileText className="h-5 w-5" aria-hidden="true" />}
        />
      </div>
    </main>
  )
}

interface NavCardProps {
  to: string
  title: string
  description: string
  icon: React.ReactNode
}

function NavCard({ to, title, description, icon }: NavCardProps) {
  return (
    <Link
      to={to}
      className="group rounded-lg border bg-card transition-colors hover:border-primary/40 hover:bg-accent"
    >
      <Card className="border-0 shadow-none">
        <CardHeader className="flex flex-row items-start gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-muted text-muted-foreground">
            {icon}
          </span>
          <div className="flex-1">
            <CardTitle className="text-base">{title}</CardTitle>
            <CardDescription className="mt-1">{description}</CardDescription>
          </div>
          <ChevronRight
            className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </CardHeader>
        <CardContent className="sr-only">{description}</CardContent>
      </Card>
    </Link>
  )
}
